import { Outlet } from "react-router";

export function SamplesBaseDataRoute() {
  return <Outlet />;
}
